'use client';

import { ElementComponents } from '@/components/sections/builder/builder-element';
import BodyElements from '@/components/sections/builder/live-site/layouts/body';
import FooterElements from '@/components/sections/builder/live-site/layouts/footer';
import HeaderElement from '@/components/sections/builder/live-site/layouts/header';
import { WrapperTheme } from '@/components/sections/builder/wrapper';
import { CommonElementDataType, ElementType, ThemeType } from '@/stores/builder';
import { useParams } from 'next/navigation';
import Cookies from 'js-cookie';
import { useProductDetail } from '@/hooks/api/storefront/product-detail';
import NotFoundPage from '@/components/sections/builder/not-found';
import LoadingProductDetailPage from '@/components/sections/builder/elements/body/product-detail/components/loading-product-detail-page';

function ClientProductDetailLive({
  builder,
}: {
  builder: { elements: ElementType[]; theme: ThemeType };
}) {
  const elements = (builder.elements || [])
    .filter(
      (element) =>
        !(element.data as CommonElementDataType)?.hidden &&
        !!ElementComponents[element.type]?.Element
    )
    .map((element) => ({
      ...element,
      childs: element.childs?.filter((child) => !(child.data as CommonElementDataType)?.hidden),
    }));

  const { slug: productSlug } = useParams<{ slug: string }>();
  const customerToken = Cookies.get('accessToken') as string;

  const { isLoading, isError } = useProductDetail(productSlug, customerToken as string);

  return (
    <WrapperTheme theme={builder.theme}>
      <HeaderElement elements={elements} theme={builder.theme} />
      {isLoading ? (
        <LoadingProductDetailPage />
      ) : isError ? (
        <NotFoundPage />
      ) : (
        <BodyElements
          elements={elements}
          group='body,body_product_detail'
          theme={builder.theme}
          isLoading={isLoading}
        />
      )}
      <FooterElements elements={elements} theme={builder.theme} />
    </WrapperTheme>
  );
}

export default ClientProductDetailLive;
